export type MasonryId = number;

export enum MasonryTrimKind {
  Base = "Base",
  Header = "Header",
  Rowlock = "Rowlock",
}
